import styled from 'styled-components';

export const Card = styled.div<{ $compact: boolean }>`
  border-radius: 8px;

  .data-card-title {
    font-size: ${(props) => (props.$compact ? '16px' : '18px')};
    padding: ${(props) => (props.$compact ? '0.75rem 1rem' : '1rem 1.5rem')};
    background: ${(props) => props.theme.$gray200};
  }

  th,
  td {
    padding: ${(props) => (props.$compact ? '0.75rem 0.5rem' : '1rem 1.5rem')};
    font-size: ${(props) => (props.$compact ? '13px' : 'inherit')};
    vertical-align: middle;
  }

  th:first-child,
  td:first-child {
    padding-left: ${(props) => (props.$compact ? '1rem' : '1.5rem')};
  }

  th:last-child,
  td:last-child {
    padding-right: ${(props) => (props.$compact ? '1rem' : '1.5rem')};
  }

  thead th {
    border-top: 0;
    border-bottom-width: 1px;
  }
`;
